import React from 'react';
import { Route, Switch, Redirect } from 'react-router';
import { useSelector, useDispatch } from 'react-redux';

import { SettingsProfil } from './profile';
import { SettingsSecurity } from './securite';
import { SettingsInvoicing } from './invoicing';
import { SettingsPreferences } from './preferences';

export const Settings = ({ roles }) => {
    const facilitaState = useSelector(state => state.facilita);
    return (
        <Switch>
            <Route exact path="/facilita/settings">
                <SettingsProfil user={facilitaState.user} isLoading={facilitaState.isLoading} roles={roles} />
            </Route>
            <Route exact path="/facilita/settings/securite">
                <SettingsSecurity user={facilitaState.user} isLoading={facilitaState.isLoading} roles={roles} />
            </Route>
            <Route exact path="/facilita/settings/invoicing">
                <SettingsInvoicing user={facilitaState.user} roles={roles} />
            </Route>
            <Route exact path="/facilita/settings/securite">
                <SettingsSecurity user={facilitaState.user} isLoading={facilitaState.isLoading} roles={roles} />
            </Route>
            <Route render={() => {
                return <Redirect exact to="/facilita/settings" />;
            }} />
        </Switch>
    );
};